import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import uniqid from 'uniqid';
import Swal from 'sweetalert2';
import { Container, Grid, Button } from '@mui/material';
import { getCollectionsComplete, updateData, getDate } from '../../assets/js/functions';
import logo from '../../assets/images/header/Logo.svg';
import puntero from '../../assets/images/inicio/puntero.png';
import diploma from '../../assets/images/aprobo/Certificado.png';
import creaDiplomaPDF from '../../assets/js/diploma';
import './styles.scss';

export default function Aprobo() {
  const [user, setUser] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    let usuario = sessionStorage.getItem('mx');
    const data = await getCollectionsComplete('usuarios/' + usuario);
    setUser(data);
  };

  const empezar = async (e) => {
    alert('Cierra la ventana para concluir la evaluacion.');
  };

  const crearDiploma = async () => {
    creaDiplomaPDF(user.nombre, diploma);
  };

  return (
    <>
      <div id='aprobo'>
        <div className='header'>
          <img src={logo} alt='logo' />
        </div>
        <Container maxWidth='md'>
          <Grid container justifyContent='center' alignItems='center' spacing={4}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <div className='container'>
                <h1>¡LOGRASTE ATERRIZAR TUS APRENDIZAJES EN GESTIÓN REMOTA!</h1>
                <p>
                  Tienes claros los elementos y herramientas
                  <br /> necesarias para liderar con éxito a tu equipo
                  <br /> desde un entorno remoto. Aplica lo aprendido
                  <br /> en tu día a día y continúa fortaleciendo tu liderazgo
                  <br /> para seguir inspirando a tu equipo hacia la excelencia.
                </p>
                <h2>
                  ¡Estamos seguros de que <br />
                  marcarás la diferencia!
                </h2>
                <br />
                <h2>Respuestas {localStorage.getItem('puntos') || 0} / 15</h2>
                <div className='iniciar'>
                  <img src={puntero} alt='img' className='puntero' />
                  <div className='btn-iniciar' onClick={() => empezar()}>
                    Terminar
                  </div>
                  <div className='btn-iniciar' onClick={() => crearDiploma()}>
                    Descargar Certificado
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
}
